<template>
  <div>
    <div class="conandack" id="conandack" v-if="this.contributions && this.contributions.length > 0">
      <h2 class="theme-background">{{ARTICLE.defaultlang=='zh'?'作者贡献声明':'Contributions Statement'}}</h2>
      <div v-for="contribution in this.contributions">
        <component :is="'jo' + item.name" v-for="item in contribution.data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </div>
    </div>
  <div class="conandack" id="acknowledgements" v-if="this.acknowledgements && this.acknowledgements.length > 0">
      <h2 class="theme-background">{{ARTICLE.defaultlang=='zh'?'致谢':'Acknowledgements'}}</h2>
    <div v-for="acknowledgement in this.acknowledgements">
      <component :is="'jo' + item.name" v-for="item in acknowledgement.data" v-bind:key="item.index" v-bind:data="item.data"></component>
    </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
              contributions: this.ARTICLE.contributions,
              acknowledgements: this.ARTICLE.acknowledgements
            }
        },
        created() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/conandack/conandack.vue